<template>
	<div class="list">
		<div class="list-header u-flex-col u-col-center u-row-center">
			<div class="change-top u-flex u-col-center u-row-between" style="display: none">
				<div class="left u-flex u-col-center u-row-center">
					<i class="el-icon-back" @click="toback"></i>
					<div class="line"></div>
					<div class="text" v-if="$locale == 'zh'" @click="top_show = !top_show">{{ data.name }}</div>
					<div class="text" v-if="$locale == 'en'" @click="top_show = !top_show">{{ data.nameEnglish }}</div>
					<i :class="top_show ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" @click="top_show = !top_show"></i>
				</div>
				<i class="el-icon-s-home" @click="tohome"></i>
			</div>
			<div class="show_list u-flex u-col-center" v-if="top_show">
				<div class="show_box u-flex u-col-center">
					<div class="show_item u-flex-col u-row-center u-col-center" v-for="(item,index) in firstlist" :key="index" @click="topath(item)">
						<img :src="item.pic" alt="">
						<span class="title">{{ item.name }}</span>
						<span class="subtitle">{{ item.nameEnglish }}</span>
					</div>
				</div>
				
			</div>
			<div class="show_bg" v-if="top_show"></div>
			<video class="index-video" id="video" @loadeddata="setVideoPoster($event)" :src="$http.url + '/sys/common/static/' + data.assets" muted :autoplay="true" loop :controls="false" :webkit-playsinline="true" playsinline :x5-playsinline="true"
			 :x-webkit-airplay="true"  preload="auto" x5-video-player-type="h5" :x5-video-player-fullscreen="true" crossorigin="anymous" type="video"></video>
			<div class="video-text  fadeInUp animated u-flex-col u-col-center u-row-center">
				<span class="span1" v-if="$locale == 'zh'">{{data.name}}</span>
				<span class="span1" v-if="$locale == 'en'">{{data.nameEnglish}}</span>
				<span class="span2" v-if="$locale == 'zh'">{{data.des}}</span>
				<span class="span2" v-if="$locale == 'en'">{{data.desEnglish}}</span>
			</div>
		</div>
		<div class="list-box" v-if="data.children">
			<div class="box-item" v-for="(item,index) in data.children" :key="index">
				<div class="top-title  fadeInUp animated u-flex-col u-col-center">
					<span class="title1" v-if="$locale == 'zh'"> {{ item.name }}</span>
					<span class="title1" v-if="$locale == 'en'"> {{ item.nameEnglish }}</span>
					<span class="title2" v-if="$locale == 'zh'"> {{ item.des }}</span>
					<span class="title2" v-if="$locale == 'en'"> {{ item.desEnglish }}</span>
				</div>
				<div class="goods-list u-flex u-col-center u-flex-wrap">
					<div class="goods-itme fadeInUp animated u-flex-col u-col-center" v-for="(a,b) in item.commodities" :key="b" @click="toinfo(a)">
						<img :src="$http.url + '/sys/common/static/' + a.picimg" alt="">
						<span class="span1" v-if="$locale == 'zh'"> {{ a.name }}</span>
						<span class="span1" v-if="$locale == 'en'"> {{ a.nameEnglish }}</span>
						<div class="span2 text_hide3" style="-webkit-box-orient: vertical;" v-if="$locale == 'zh'"> {{ a.introduce }}</div>
						<span class="span2 text_hide3" style="-webkit-box-orient: vertical;" v-if="$locale == 'en'"> {{ a.introduceEnglish }}</span>
					</div>
				</div>
			</div>
			<!-- <div class="label-list">
				<div class="label-item u-flex-col u-col-center u-row-center" @click="changefirstlabel(-1)">
					<span :style="{color:firstactive == -1 ? '#3FB56F' : '#fff'}">{{$t('全部')}}</span>
					<img :style="{opacity:firstactive == -1 ? 1 : 0}" src="../assets/imgs/news1-1.png" alt="">
				</div>
				<div class="label-item u-flex-col u-col-center u-row-center" v-for="(item,index) in firstlist" :key="index" @click="changefirstlabel(index)">
					<span v-if="$locale == 'zh'" :style="{color:firstactive == index ? '#3FB56F' : '#fff'}">{{item.name}}</span>
					<span v-if="$locale == 'en'" :style="{color:firstactive == index ? '#3FB56F' : '#fff'}">{{item.nameEnglish}}</span>
					<span v-if="$locale == 'de'" :style="{color:firstactive == index ? '#3FB56F' : '#fff'}">{{item.nameGerman}}</span>
					<img :style="{opacity:firstactive == index ? 1 : 0}" src="../assets/imgs/news1-1.png" alt="">
				</div>
			</div>
			<div class="label-list" v-if="lastlist.length > 0">
				<div class="label-item u-flex-col u-col-center u-row-center" @click="changelastlabel(-1)">
					<span :style="{color:lastactive == -1 ? '#3FB56F' : '#fff'}">{{$t('全部')}}</span>
				</div>
				<div class="label-item u-flex-col u-col-center u-row-center" v-for="(item,index) in lastlist" :key="index" @click="changelastlabel(index)">
					<span v-if="$locale == 'zh'" :style="{color:lastactive == index ? '#3FB56F' : '#fff'}">{{item.name}}</span>
					<span v-if="$locale == 'en'" :style="{color:lastactive == index ? '#3FB56F' : '#fff'}">{{item.nameEnglish}}</span>
					<span v-if="$locale == 'de'" :style="{color:lastactive == index ? '#3FB56F' : '#fff'}">{{item.nameGerman}}</span>
				</div>
			</div>
			<div class="goods-list u-flex u-col-center u-row-between u-flex-wrap">
				<div class="goods-itme u-flex-col u-col-center" v-for="(item,index) in goodslist" :key="index" @click="toinfo(item)">
					<img :src="item.pic" alt="">
					<span class="span1" v-if="$locale == 'zh'">{{item.name}}</span>
					<span class="span1" v-if="$locale == 'en'">{{item.nameEnglish}}</span>
					<span class="span1" v-if="$locale == 'de'">{{item.nameGerman}}</span>
					<span class="span2">{{item.modelNumber}}</span>
				</div>
				<div class="goods-itme"></div>
				<div class="goods-itme"></div>
				<div class="goods-itme"></div>
				<div class="goods-itme"></div>
			</div> -->
			<el-empty :description="$t('暂无数据')" v-if="data.children.length == 0"></el-empty>
		</div>
		<div class="list-box" v-else>
			<el-empty :description="$t('暂无数据')"></el-empty>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				firstactive: -1,
				firstlist: [],
				lastactive: -1,
				lastlist: [],
				goodslist:[],
				indexdata:{},
				id: '',
				data: {},
				top_show: false
			}
		},
		created() {
			this.id = this.$route.query.id
			this.getlist()
			this.getfirstlabel()
			/* this.getfirstlabel()
			this.getgoods()
			this.getindexddata() */
		},
		mounted(){
			window.addEventListener('touchstart',function(){
				document.getElementById('video').play()
				console.log('开始播放');
			})
			// this.$parent.settitle(this.$t('全部手表'))
		},
		methods: {
			setVideoPoster(event) {
				let video = event.target;
				// video.height = video.clientHeight;
				let canvas = document.createElement("canvas"); // 创建 canvas
				const ctx = canvas.getContext("2d");
				video.currentTime = 1; // 第一帧
				video.oncanplay = () => {
					canvas.width = video.clientWidth; // 获取视频宽度
					canvas.height = video.clientHeight; //获取视频高度
					var img = new Image(); // 这里使用img是为了解决视频跨域 canvas.toDataURL会提示错误的问题
					img.onload = function () {
						// canvas绘图
						ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
						// 转换成base64形式并设置封面
						video.poster = canvas.toDataURL("image/jpeg", 1); // 截取后的视频封面
					}
				}
			},
			topath(item) {
				this.top_show = false
				if(this.$route.path == '/list') {
					this.$router.push({ path: '/list',query: {id: item.id} }); 
					location.reload()
				} else {
					this.$router.push({
						path: "/list",
						query: {
							id: item.id
						}
					})
				}
			},
			toback() {
				this.$router.go(-1)
			},
			tohome() {
				this.$router.push({
					path:"/"
				})
			},
			getlist() {
				this.$http.get('/api/Index/queryCommodityFl?commodityFlId=' + this.id).then((res) => {
					this.data = res.result
					for(var i=0;i<this.data.children.length;i++) {
						for(var j=0;j<this.data.children[i].commodities.length;j++) {
							if(this.data.children[i].commodities[j].pic.includes(',')) {
								this.data.children[i].commodities[j].pic = this.data.children[i].commodities[j].pic.split(',')
								this.data.children[i].commodities[j].picimg = this.data.children[i].commodities[j].pic[0]
							} else {
								this.data.children[i].commodities[j].picimg = this.data.children[i].commodities[j].pic
							}
						}
					}
				})
			},
			getindexddata(){
				// this.$http.post('/api/Index/getPoster').then(res => {
				// 	this.indexdata = res.result
				// })
				this.$http.post('/api/Index/indexInfo').then(res => {
					this.indexdata = res.result
				})
			},
			changelastlabel(active){
				this.lastactive = active
				this.getgoods()
			},
			
			changefirstlabel(active) {
				this.firstactive = active
				this.lastactive = -1
				if (active == -1) {
					this.lastlist = []
					this.lastactive = -1
					this.getgoods()
				}else{
					this.getlastlabel()
				}
			},
			getlastlabel() {
				this.$http.post('/api/Index/gete',{
					id:this.firstlist[this.firstactive].id
				}).then(res => {
					this.lastlist = res.result
					this.getgoods()
				})
			},
			getfirstlabel() {
				this.$http.post('/api/Index/gety').then(res => {
					this.firstlist = res.result
				})
			},
			toinfo(item) {
				this.$router.push({
					path: "/info",
					query:{
						id:item.id
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	.fadeInUp {
		-webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
		visibility: visible;
	}
	.animated {
    -webkit-animation-duration: 1.5s;
    animation-duration: 1.5s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
	}
	@keyframes fadeInUp {
		0% {
			opacity: 0;
			-webkit-transform: translate3d(0,100%,0);
			transform: translate3d(0,100%,0);
		}
		100% {
			opacity: 1;
			-webkit-transform: none;
			transform: none;
		}
	}
</style>
